const TermsPage = () => (
  <div className="max-w-2xl mx-auto p-4">
    <h2 className="text-2xl font-bold mb-4">Terms of Service</h2>
    <p>Your terms of service text goes here...</p>
  </div>
);
export default TermsPage;
